module.exports = __webpack_public_path__ + "resources/img/logo_youngwoo.59d573c9499c9804975edbc1a91ba519.png";